import { useLocation, Navigate } from 'react-router-dom';
import ViewQR from './components/ViewQR';
import UpdateQR from './components/UpdateQR';
import CustomPage from './components/CustomPage';

function CustomRouter() {
  const { pathname } = useLocation();

  if (/^\/g[a-zA-Z0-9_-]{6}$/.test(pathname)) {
    return <ViewQR />;
  }

  if (/^\/u[a-zA-Z0-9_-]{6}$/.test(pathname)) {
    return <UpdateQR />;
  }

  // Handle custom pages with URL pattern /p/page_slug
  const customPageMatch = pathname.match(/^\/p\/([a-zA-Z0-9_-]+)$/);
  if (customPageMatch) {
    // Extract the slug from the URL and pass it as a prop
    const slug = customPageMatch[1];
    return <CustomPage slug={slug} />;
  }

  return <Navigate to="/" />;
}

export default CustomRouter;
